export const WHATSAPP_PHONE = "3206037344";
export const WHATSAPP_URL = "https://wa.me/3206037344";
export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/place/Entorno+Biai+SAS/@6.9614714,-75.4167016,15z/data=!4m2!3m1!1s0x0:0xea84e6a68cf01e9?sa=X&ved=1t:2428&ictx=111";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61554331737569&locale=es_LA";
export const INSTAGRAM_URL = "https://www.instagram.com/entornobiai";
